import { Grid } from '@mui/material';
import { ChangeEvent, forwardRef, KeyboardEvent, useCallback, useImperativeHandle, useRef, useState } from 'react';
import { useStyles } from './ConfirmationCodeInput.styles';
import { NumberFormat } from '@/components/number-format';
import { HelperText, TextField, TextFieldProps } from '@/ui/kit/components/textfield';
import { useOtpAutoFill } from '@/components/confirmation-code-input/UseOtpAutoFill';
interface ConfirmationCodeInputProps extends TextFieldProps {
  inputCount?: number;
  onComplete: (code: string) => void;
  errorMessage?: string;
}
export const ConfirmationCodeInput = forwardRef<{
  value: string;
}, ConfirmationCodeInputProps>(function ConfirmationCodeInput({
  inputCount = 6,
  onComplete,
  errorMessage,
  ...inputProps
}: ConfirmationCodeInputProps, ref) {
  const {
    classes
  } = useStyles();
  const refs = useRef<HTMLInputElement[]>([]);
  const [values, setValues] = useState([...Array<string>(inputCount)].fill(''));
  useOtpAutoFill(otpCode => {
    if (otpCode.length === inputCount) {
      setValues(otpCode.split(''));
      onComplete(otpCode);
    }
  });
  const inputChange = useCallback((e: ChangeEvent<HTMLInputElement>, i: number) => {
    const {
      value
    } = e.target;
    setValues(prevState => {
      let newState = [];
      if (value.length > 1) {
        newState = prevState.map((item, index) => index < i || index >= i + value.length ? item : value[index - i]);
      } else {
        prevState[i] = value;
        newState = [...prevState];
      }
      if (newState.join('').length === inputCount) {
        refs.current[i].blur();
        onComplete(newState.join(''));
      } else if (value !== '' && refs.current[i + value.length]) {
        refs.current[i + value.length].focus();
      }
      return newState;
    });
  }, [inputCount, onComplete]);
  const inputKeyDown = (e: KeyboardEvent<HTMLInputElement>, i: number) => {
    if (e.key === 'Backspace' && !values[i]) {
      setValues(prevState => {
        prevState[i - 1] = '';
        return [...prevState];
      });
      refs.current[i - 1] && refs.current[i - 1].focus();
    }
  };
  useImperativeHandle(ref, () => {
    return {
      value: values.join('')
    };
  }, [values]);
  return <>
      <Grid container className={classes.root} spacing={1}>
        {values.map((_, i) => <Grid key={i} item xs>
            <NumberFormat autoComplete={i === 0 ? 'one-time-code' : 'off'} autoFocus={i === 0} customInput={TextField} error={Boolean(errorMessage)} inputRef={(ref: HTMLInputElement) => refs.current[i] = ref} size='large' type='tel' value={values[i]} InputProps={{
          sx: {
            textAlign: 'center'
          },
          ...inputProps
        }} onChange={(e: ChangeEvent<HTMLInputElement>) => inputChange(e, i)} onKeyDown={(e: KeyboardEvent<HTMLInputElement>) => inputKeyDown(e, i)} onFocus={() => {
          refs.current[i].select();
        }} />
          </Grid>)}
      </Grid>
      {errorMessage && <HelperText className={classes.helper} type='error'>
          {errorMessage}
        </HelperText>}
    </>;
});